import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { secondsToPixels } from 'utils/timeline'

const useTimelineItemBodyRect = ({
  trimStart = 0,
  originalDuration = 0
}: {
  trimStart?: number
  originalDuration?: number
}) => {
  const timelineRulerSliceDuration = useSelector(
    editorSelectors.timelineRulerSliceDuration
  )
  const pixelsPerSecond = useMemo(
    () => secondsToPixels(1, timelineRulerSliceDuration),
    [timelineRulerSliceDuration]
  )

  return {
    bodyWidth: originalDuration * pixelsPerSecond,
    bodyLeft: -(trimStart * pixelsPerSecond)
  }
}

export default useTimelineItemBodyRect
